
  import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
  export default {
    name: 'SearchInputField',
    props: {
        leftMargin: {
            type: String,
            default: '0px;',
        },
        isBlogType: {
            type: Boolean,
            default: false,
        },
        isThemeStockSearch: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            inputText: '',
            toggle: false,
            currentFocus: -1,
        }
    },
  
    computed: {
        CorpList() {
            // 일치하는 기업이름이나, 코드를 찾아 필터링 해서 array로 return
            const CorpList = this.initList()
  
            const parsedobj = CorpList && JSON.parse(JSON.stringify(CorpList))
  
            if (this.inputText.length > 1) {
                const result =
                    parsedobj &&
                    parsedobj.filter(
                        (item) =>
                            item.code
                                .toLowerCase()
                                .includes(
                                    this.inputText.toLowerCase().trim()
                                ) ||
                            item.name
                                .toLowerCase()
                                .includes(this.inputText.toLowerCase().trim())
                    )
  
                if (result.length === 0) {
                    return [{ name: '해당되는 종목이 없습니다.' }]
                } else {
                    // 22.05.18 suye 종목 검색 추천값에서 종목명순(길이,한글>영어) 정렬
                    result.sort((a, b) => {
  
                        if(a.name.length > b.name.length) { return 1 } 
                        if(a.name.length < b.name.length) { return -1 }
  
                        if(a.name > b.name) { return -1 } 
                        if(a.name < b.name) { return 1 }
  
                        if(a.name.localeCompare(b.name) > b.name.localeCompare(a.name)) { return -1 }
                        if(a.name.localeCompare(b.name) < b.name.localeCompare(a.name)) { return 1 }
  
                    }) 
                    return result
                }
            }
  
            return ''
        },
    },
  
    watch: {
        inputText() {
            // 2자 이상 입력시, 자동완성창이 토글되도록 설정
            if (this.inputText.length > 1) {
                this.toggle = true
            } else {
                this.toggle = false
            }
            // 새로 입력하면 포커스 해제
            this.releaseFocus()
  
            if (this.$refs.li_refs !== undefined) {
                this.removeActive()
            }
        },
    },
  
    // 자동완성창 바깥쪽 클릭 시, 토글 해제하기 위한 click 이벤트리스너
    beforeMount() {
        window.addEventListener('click', this.closeAllLists)
    },
    beforeDestroy() {
        window.removeEventListener('click', this.closeAllLists)
    },
    methods: {
        ...mapGetters('initial', ['initList']),
      //   2023 컨센서스
        ...mapActions('search', ['GET_CORP_INFO','GET_CORP_CONSENSUS', 'GET_CORP_CONSENSUS_CHART']),
  
        getData() {
            console.log('isBlogType=', this.isBlogType)
  
            if (this.isBlogType) {
                this.$emit('inputText', this.inputText)
                this.inputText = ''
                return
            }
  
            // 종목입체분석에서 쓰는 경우만 별도로 store 처리
            this.GET_CORP_INFO({
                inputText: this.inputText,
            })
            this.GET_CORP_CONSENSUS({
              inputText: this.inputText,
            })
            this.GET_CORP_CONSENSUS_CHART({
              inputText: this.inputText,
            })
            this.inputText = ''
        },
        linkPage() {
            this.GET_CORP_INFO(this.inputText)
            this.GET_CORP_CONSENSUS(this.inputText)
            this.GET_CORP_CONSENSUS_CHART(this.inputText)
  
            this.inputText = ''
        },
        /* 22.05.17 suye 종목검색 */
        hitEnter(event) {
            /* 220530 meej toggle = false 추가 */
            this.toggle = false
  
            // 검색값 입력 제어 
            if (this.inputText.trim() === '') {
                alert('코드나 종목명을 입력해주세요.')
            } else if (this.CorpList[0].code === undefined) {
                alert('상장폐지되었거나 존재하지 않는 종목입니다.')
            } else {
            // 검색값 존재시 
                // selectBox 선택시
                if (this.currentFocus > -1) {
                    const ref = this.$refs.li_refs
                    const selectedItem = ref.filter(
                        (item) => item.className === 'autocomplete-active'
                    )
                    if (
                        selectedItem[0].textContent.trim() !==
                        '해당되는 종목이 없습니다.'
                    ) {
                        const regexRule = /[0-9]{2}\s*-?\s*[0-9]{2}\s*-?\s*[0-9]{2}/
                        const code = regexRule.exec(selectedItem[0].textContent)[0]
                        /* 220530 meej name 추가 */
                        const codeName = selectedItem[0].textContent.trim().split("\n")[0]
  
                        if (this.isBlogType) {
                            /* 220530 meej name 추가 */
                            this.$emit('inputText', code, codeName)
                            event.target.value = ''
                            return
                        }
  
                        if(this.isThemeStockSearch){
                            const stock = {stockCode: code, stockName: codeName}
                            this.$emit('getStockThemeSearch', stock) // 테마DB 관련종목검색 
                        }
                        this.GET_CORP_INFO(code)
                        this.GET_CORP_CONSENSUS(code)
                        this.GET_CORP_CONSENSUS_CHART(code)
                    }
                } else if (this.currentFocus === -1) { // selectBox 미선택시
                    try {
                        // 검색값 올바를 경우 이동
                        this.linkPage()      
                        } 
                    finally {
                        // 해당 검색 오류시 selectBox의 첫번째값 검색
                        const ref = this.$refs.li_refs
                        // console.log('ref', ref)
                        ref[0].className = 'autocomplete-active'
                        const selectedItem = ref
                        if (
                            selectedItem[0].textContent.trim() !==
                            '해당되는 종목이 없습니다.'
                        ) {
                            const regexRule = /[0-9]{2}\s*-?\s*[0-9]{2}\s*-?\s*[0-9]{2}/
                            const code = regexRule.exec(selectedItem[0].textContent)[0]
                            /* 220530 meej name 추가 */
                            const codeName = selectedItem[0].textContent.trim().split("\n")[0]
  
                            if(this.isThemeStockSearch){
                                const stock = {stockCode: code, stockName: codeName}
                                this.$emit('getStockThemeSearch', stock) // 테마DB 관련종목검색 
                            }
                            this.GET_CORP_INFO(code)
                            this.GET_CORP_CONSENSUS(code)
                            this.GET_CORP_CONSENSUS_CHART(code)
  
                            if (this.isBlogType) {
                                /* 220530 meej name 추가 */
                                this.$emit('inputText', code, codeName)
                            }
                        }
                        }   
                    }  
                this.inputText = ''
                event.target.value = ''
                this.$refs.stocksearch.value = '' // 검색필드 클리어
                } 
            },
        // 키보드로 자동완성 선택 후, 엔터를 누르면, 그 항목에 대한 검색이 되도록 하는 메소드
        // hitEnter(event) {
        //     if (this.currentFocus > -1) {
        //         const ref = this.$refs.li_refs
  
        //         const selectedItem = ref.filter(
        //             (item) => item.className === 'autocomplete-active'
        //         )
  
        //         if (
        //             selectedItem[0].textContent.trim() !==
        //             '해당되는 종목이 없습니다.'
        //         ) {
        //             const regexRule = /[0-9]{2}\s*-?\s*[0-9]{2}\s*-?\s*[0-9]{2}/
        //             const code = regexRule.exec(selectedItem[0].textContent)[0]
  
        //             this.inputText = ''
        //             this.toggle = false
        //             this.currentFocus = -1
  
        //             if (this.isBlogType) {
        //                 this.$emit('inputText', code)
        //                 event.target.value = ''
        //                 return
        //             }
  
        //             event.target.value = ''
        //             this.GET_CORP_INFO(code)
        //         }
        //     }
        // },
        onBoxClick(item) {
            /* 220530 meej name 추가 */
            this.inputText = ''
            this.toggle = false
            this.currentFocus = -1
            this.$refs.stocksearch.value = ''
  
            if (item.code) {
                if (this.isBlogType) {
                    this.$emit('inputText', item.code, item.name)
                    return
                }
  
                if(this.isThemeStockSearch){
                    const stock = {stockCode: item.code, stockName: item.name}
                    this.$emit('getStockThemeSearch', stock) // 테마DB 관련종목검색 
                }
                this.GET_CORP_INFO(item.code)
                this.GET_CORP_CONSENSUS(item.code)
                this.GET_CORP_CONSENSUS_CHART(item.code)
            }
        },
        // 자동완성 창, 키보드로 이동 시, 따라가도록 하는 부분
        outboundScrolling() {
            const ref = this.$refs.li_refs
  
            if (
                ref[this.currentFocus].offsetTop <
                ref[this.currentFocus].parentNode.scrollTop
            ) {
                // Hidden on top, move scroll to show item
                // Just to the top of item
                ref[this.currentFocus].parentNode.scrollTop =
                    ref[this.currentFocus].offsetTop
            } else if (
                ref[this.currentFocus].offsetTop >
                ref[this.currentFocus].parentNode.scrollTop +
                    ref[this.currentFocus].parentNode.clientHeight -
                    ref[this.currentFocus].clientHeight
            ) {
                // Hidden on bottom, move scroll to top of item + item height
                ref[this.currentFocus].parentNode.scrollTop =
                    ref[this.currentFocus].offsetTop -
                    (ref[this.currentFocus].parentNode.clientHeight -
                        ref[this.currentFocus].clientHeight)
            }
        },
        // esc 누를 시, 자동완성창 사라지게 만드는 부분
        keyEscape() {
            this.toggle = false
            this.currentFocus = -1
        },
  
        keyDown() {
            const ref = this.$refs.li_refs
  
            if (ref !== undefined && ref.length - 1 > this.currentFocus) {
                this.removeActive()
                this.currentFocus++
                ref[this.currentFocus].classList.add('autocomplete-active')
  
                this.outboundScrolling()
            }
        },
  
        keyUp() {
            const ref = this.$refs.li_refs
  
            if (this.currentFocus > 0) {
                this.removeActive()
                this.currentFocus--
                ref[this.currentFocus].classList.add('autocomplete-active')
  
                this.outboundScrolling()
            }
        },
  
        // active 넣어 준 클래스를 전체 회수하는 부분
        removeActive() {
            for (let i = 0; i < this.$refs.li_refs.length; i++) {
                this.$refs.li_refs[i].classList.remove('autocomplete-active')
            }
        },
        closeAllLists(elem) {
            const ref = this.$refs.li_refs
  
            if (
                elem.target.className !== 'autobox' &&
                elem.target.className !== 'header-searchbar'
            ) {
                this.toggle = false
            }
        },
        releaseFocus() {
            this.currentFocus = -1
        },
    },
  }
  